import { File, FileArchive, FileImage, FileSpreadsheet, FileText } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Returns a Lucide icon element appropriate for the given file name / extension.
 *
 * @param fileName - file name (or basename) used to derive the extension
 * @param size     - "sm" → 16 px (h-4 w-4), "lg" → 40 px (h-10 w-10)
 */
export function getFileIcon(fileName: string, size: "sm" | "lg" = "sm") {
  const ext = fileName.split(".").pop()?.toLowerCase();
  const cls = size === "sm" ? "h-4 w-4 shrink-0" : "h-10 w-10 shrink-0";
  switch (ext) {
    case "pdf":
      return <FileText className={cn(cls, "text-destructive")} />;
    case "doc":
    case "docx":
      return <FileText className={cn(cls, "text-primary")} />;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "svg":
      return <FileImage className={cn(cls, "text-blueprint-core")} />;
    case "zip":
    case "rar":
    case "tar":
    case "7z":
      return <FileArchive className={cn(cls, "text-warning")} />;
    case "xls":
    case "xlsx":
    case "csv":
      return <FileSpreadsheet className={cn(cls, "text-blueprint-core")} />;
    default:
      return <File className={cn(cls, "text-muted-foreground")} />;
  }
}
